import { render, staticRenderFns } from "./AgencyChooseProjectType.vue?vue&type=template&id=71c5aeae&scoped=true&"
import script from "./AgencyChooseProjectType.vue?vue&type=script&lang=js&"
export * from "./AgencyChooseProjectType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c5aeae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib'
installComponents(component, {VSelect})
